import { render, staticRenderFns } from "./AllocationMobileTabs.vue?vue&type=template&id=a6e6e6ce"
import script from "./AllocationMobileTabs.vue?vue&type=script&lang=js"
export * from "./AllocationMobileTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports